import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CoreStateService, I18nService } from '@app/core/services';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { CoreConfig, CorePlugin } from '@app/core/plugin';

@Component({
  selector: 'app-card-statistic',
  templateUrl: './card-statistic.component.html',
  styleUrls: ['./card-statistic.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardStatisticComponent {
  public statistics$: Observable<any[]>;

  constructor(
    private coreStateService: CoreStateService,
    private i18nService: I18nService,
    private translateService: TranslateService,
  ) {
    this.statistics$ = this.coreStateService.state$.pipe(
      switchMap(this.awaitTranslation),
      map((config) =>
        [
          config.statistic,
          {
            label: this.translateService.instant('statistics.institutions-worldwide'),
            value: '10.322',
            image: 'assets/svg/instituicoes.svg',
            class: 'pl-0 lg:pl-32',
          },
          {
            label: this.translateService.instant('statistics.students-world'),
            value: '2.330.305',
            image: 'assets/svg/alunos.svg',
            class: 'pl-0 lg:pl-64',
          },
        ].filter((statistic) => !!statistic),
      ),
    );
  }

  private awaitTranslation = (config: CoreConfig): Observable<CorePlugin> =>
    this.i18nService.translation(config).pipe(map(() => config.plugin));
}
